import common from './common.json'
import menu from './menu.json'
import road from './road.json'
import decision from './decision.json'
import model from './model.json'
import login from './login.json'
import system from './system.json'

export default {
  common,
  menu,
  road,
  decision,
  model,
  login,
  system,
}
